import kr from '../kr/kr';
import HTMLClass from '../kr/utils/HTMLClass';
import LoadingHelper from '../kr/utils/LoadingHelper';

export default class Newsletter extends kr.Component {
    init() {
        this.$ = window.jQuery;
        this.ajax_url = window.ajax_url;
        this.$helper = new LoadingHelper();
        this.$form = this.$element.querySelector('form');
        this.$submit = this.$element.querySelector('.newsletter__form-submit');
        this.$input = this.$element.querySelector('.newsletter__input');
        this.calling = false;
        this.bind();
    }

    bind()
    {
        this.$form.addEventListener('submit', async (event) => {
            event.preventDefault();
            if (!this.validateEmail(this.$input.value)) {
                this.$helper.message(this.$form, 'incorrect email', 'error');
                return false;
            }

            if (this.calling) {
                return false;
            }

            this.calling = true;
            this.$submit.disabled = true;
            this.$helper.showLoader(this.$form);
            const email = this.$input.value;
            let result;
            try {
                result = await this._send(email);
            } catch (error) {
                this.$helper.message(this.$form, 'undefined error', 'error');
                this.$helper.hideLoader();
                this.$submit.disabled = false;
                this.calling = false;
            }
            
            if (!result.success) {
                this.$helper.message(this.$form, result.message, 'error');
            } else {
                this.$helper.message(this.$form, result.message);
                this.$input.value = '';

            }
            this.$helper.hideLoader();
            this.$submit.disabled = false;
            this.calling = false;
        });
    }

    async _send(email)
    {
        const data = {
            action: 'subNewsletter',
            email: email
        }
        const result = await this.$.post(this.ajax_url, data).then().fail();
        return JSON.parse(result);
    }

    validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
}

kr.registerComponent('.newsletter', {
    component: Newsletter
});
